const PostLoading = "newsLoading";
const PostFailure = "newsFailure";
const getAllPost = "addPost";
const ChangeGenre = "chnageGenre";
const addComment = "addComment";

export {PostLoading,PostFailure,getAllPost,ChangeGenre,addComment};